<div class="inner-container vo-list-view-inner-container">
  <div class="addresses-list">
    <ng-container *ngFor="let dataItem of dataList; let i = index;">
      <div *ngIf="getDataItemDisplayName(dataItem) as itemDisplayName" class="bo-info-text vo-address-item"
        [ngClass]="{'selected-item': selectedValue === dataItem, 'address-item--odd': i % 2 == 1}"
        (click)="onSelectedValueChange(dataItem)">
        <strong *ngIf="dataItem.Name" [innerHtml]="dataItem.Name"></strong>
        <p [innerHtml]="itemDisplayName"></p>
      </div>
    </ng-container>
  </div>
</div>